import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Button } from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Cropper from "react-easy-crop";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import noImage from "../../../../../../src/assets/images/settings/no-image.png";
import { serverInfo } from "../../../../../App";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import "./AddSuperStar.css";
import "./EditSuperStar.css";
import getCroppedImg from "./cropImage";
import { styles } from "./styles";
import useCoverChange from "../../../../../CustomHooks/useCoverChange";
import useProfileChange from "../../../../../CustomHooks/useProfileChange";

const Demo = ({ classes }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [coverPhoto, setCoverPhoto] = useState("");
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [profileImage, setProfileImage] = useState("");

  const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);
  const [profileModalShow, setProfileModalShow] = useState(false);
  const [profileCrop, setProfileCrop] = useState({ x: 0, y: 0 });
  const [profileZoom, setProfileZoom] = useState(1);


    // Cover Change
    const [croppedImage, setCroppedImage] = useState('');
    const [coverDelKey, setCoverDelKey] = useState(null);
    const [coverUrl, coverKey, coverProgress] = useCoverChange(croppedImage, 'profile/superstar/cover', coverDelKey);
  
    // Cover Change
    const [profileCroppedImage, setProfileCroppedImage] = useState('');
    const [profileDelKey, setProfileDelKey] = useState(null);
    const [profileUrl, profileKey, profileProgress] = useProfileChange(profileCroppedImage, 'profile/superstar/image', profileDelKey);
  
  

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        coverPhoto,
        croppedAreaPixels,
      );
      setCroppedImage(croppedImage);
      setModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [coverPhoto, croppedAreaPixels]);

  const profileShowCroppedImage = useCallback(async () => {
    try {
      const profileCroppedImage = await getCroppedImg(
        profileImage,
        profileCroppedAreaPixels
      );
      setProfileCroppedImage(profileCroppedImage);
      setProfileModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [profileImage, profileCroppedAreaPixels]);

  const handleCoverChange = (e) => {
    setCoverPhoto(URL.createObjectURL(e.target.files[0]));
  };

  const handleProfileChange = (e) => {
    setProfileImage(URL.createObjectURL(e.target.files[0]));
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const profileOnCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setProfileCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  const handleShow = (e) => {
    e.preventDefault();
    setModalShow(true)};
  const handleClose = () => setModalShow(false);
  const handleProfileShow = (e) => {
    e.preventDefault();
    setProfileModalShow(true)
  };
  const handleProfileClose = () => setProfileModalShow(false);

  const fileRef = useRef();
  const filePro = useRef();

  const history = useHistory();

  const { star_id } = useParams();

  const { imageCdnUrl } = useContext(serverInfo);

  const [loading, setLoading] = useState(true);
  const [signaturefile, setsignaturefile] = useState("");
  const [viewSignaturefile, setViewSignaturefile] = useState("");
  const [star, setStar] = useState({});
  const [starDetails, setStarDetails] = useState("");
  const [profileFileOne, setProfileFileOne] = useState("");
  const [profileFileTwo, setProfileFileTwo] = useState("");

  const [error_list, setErrorList] = useState([]);


  const handleProfileOneChange = (file) => {
    setProfileFileOne(file[0]);
  };

  const handleSignatureChange = (file) => {
    setViewSignaturefile(URL.createObjectURL(file[0]));
    setsignaturefile(file[0]);
  };

  const handleProfileTwoChange = (file) => {
    setProfileFileTwo(file[0]);
  };

  // Editor Funtionalities //
  const [convertedContent, setConvertedContent] = useState('');

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/user_info/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setStar(res.data.users);
        // setFile(imageCdnUrl + res.data.users?.image);
        if (res.data.star_details?.qr_code != null) {
          setStarDetails(res.data?.star_details);
          setViewSignaturefile(
            res.data.star_details?.signature
              ? imageCdnUrl + res.data.star_details?.signature
              : ""
          );
        }
      }
    });
    setLoading(false);
  }, [star_id]);

  const registerSubmit = () => {

    const fData = new FormData();
    fData.append("star_id", star.id);
    fData.append("terms_and_condition", convertedContent);
    fData.append("signature", signaturefile);
    fData.append("cover_photo", coverKey?coverKey:star?.cover_photo);
    fData.append("profile_photo", profileKey?profileKey:star?.image);
    fData.append("profile_file_one", profileFileOne);
    fData.append("profile_file_two", profileFileTwo);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/star_register`, fData).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          setProfileFileOne("");
          setProfileFileTwo("");
          setConvertedContent(null);
          history.push("/superstar-admin/superstars");
        } else {
          setErrorList(res.data.validation_errors);
        }
      });
    });
  };

  if (loading) {
    return <LoaderPost />;
  }
  return (
    <>
      <AllDataHeader title="Star Profile Registration" count={0} />

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-10 col-lg-8 mx-auto">

                  <div
                    className="col-md-12 details mt-3  px-0 pb-3 rounded-3 "
                    style={{ position: "relative" }}
                  >
                    <div className="profile-container">
                      {croppedImage ? (
                        <img
                          src={croppedImage}
                          className="img-fluid profile-cover mx-auto"
                          alt="cover_photo"
                        />
                      ) : (
                        <img
                          src={
                            star.cover_photo != null
                              ? imageCdnUrl + star.cover_photo
                              : noImage
                          }
                          className="img-fluid profile-cover"
                          alt="cover_photo"
                        />
                      )}
                    </div>

                    <button className="bottomright" onClick={handleShow}>
                      <i className="fa-solid fa-camera"></i>
                    </button>

                    <Modal
                      show={modalShow}
                      onHide={handleClose}
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Body>
                        <div>
                          <div className={classes.cropContainer}>
                            <Cropper
                              image={coverPhoto}
                              crop={crop}
                              zoom={zoom}
                              aspect={1250 / 450}
                              onCropChange={setCrop}
                              onCropComplete={onCropComplete}
                              onZoomChange={setZoom}
                            />
                          </div>
                          <div className={classes.controls}>
                            <div className={classes.sliderContainer}>
                              <Typography
                                variant="overline"
                                classes={{ root: classes.sliderLabel }}
                              >
                                Zoom
                              </Typography>
                              <Slider
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="Zoom"
                                classes={{ root: classes.slider }}
                                onChange={(e, zoom) => setZoom(zoom)}
                              />
                            </div>

                            <input
                            accept="image/*"
                              ref={fileRef}
                              onChange={handleCoverChange}
                              multiple={false}
                              type="file"
                              hidden
                            />
                            <Button
                              onClick={showCroppedImage}
                              variant="contained"
                              color="primary"
                              classes={{ root: classes.cropButton }}
                            >
                              Save
                            </Button>
                            <Button
                              onClick={() => fileRef.current.click()}
                              variant="contained"
                              color="primary"
                              classes={{ root: classes.cropButton }}
                            >
                              Choose
                            </Button>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>

                    <div className="profile-div mb-5">
                      <div className="profile-photo">
                        <div className="d-flex justify-content-center">
                          {profileCroppedImage ? (
                            <img
                              src={profileCroppedImage}
                              alt=""
                              className="img-fluid profile-img-pro"
                            />
                          ) : (
                            <img
                              src={
                                star.image != null
                                  ? imageCdnUrl + star.image
                                  : noImage
                              }
                              alt=""
                              className="img-fluid profile-img-pro"
                            />
                          )}
                        </div>

                        <button
                          className="profile-pic-cam cam-po"
                          onClick={handleProfileShow}
                        >
                          <i className="fa-solid fa-camera"></i>
                        </button>

                        <Modal
                          show={profileModalShow}
                          onHide={handleProfileClose}
                          size="lg"
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                        >
                          <Modal.Body>
                            <div>
                              <div className={classes.cropContainer}>
                                <Cropper
                                  image={profileImage}
                                  crop={profileCrop}
                                  zoom={profileZoom}
                                  aspect={720 / 720}
                                  onCropChange={setProfileCrop}
                                  onCropComplete={profileOnCropComplete}
                                  onZoomChange={setProfileZoom}
                                />
                              </div>
                              <div className={classes.controls}>
                                <div className={classes.sliderContainer}>
                                  <Typography
                                    variant="overline"
                                    classes={{ root: classes.sliderLabel }}
                                  >
                                    Zoom
                                  </Typography>
                                  <Slider
                                    value={profileZoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    classes={{ root: classes.slider }}
                                    onChange={(e, profileZoom) => setProfileZoom(profileZoom)}
                                  />
                                </div>

                                <input
                                accept="image/*"
                                  ref={filePro}
                                  onChange={handleProfileChange}
                                  multiple={false}
                                  type="file"
                                  hidden
                                />
                                <Button
                                  onClick={profileShowCroppedImage}
                                  variant="contained"
                                  color="primary"
                                  classes={{ root: classes.cropButton }}
                                >
                                  Save
                                </Button>
                                <Button
                                  onClick={() => filePro.current.click()}
                                  variant="contained"
                                  color="primary"
                                  classes={{ root: classes.cropButton }}
                                >
                                  Choose
                                </Button>
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </div>
                  </div>

                  <br />
                  <div className="row mt-5">
                    <div className="col-md-6 mb-3">
                      <label className="label-text py-2">First Name</label>
                      <input
                        type="text"
                        className="form-control reply-control"
                        name="first_name"
                        value={star.first_name}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="label-text py-2">Last Name</label>
                      <input
                        type="text"
                        className="form-control reply-control"
                        name="last_name"
                        value={star.last_name}
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="label-text py-2">Terms and Conditions</label>
                      <CKEditor
                        name="terms_and_condition"
                        data={
                          starDetails?.terms_and_condition  ? starDetails?.terms_and_condition : ""
                        }
                        editor={ClassicEditor}
                        onChange={(event, editor) => { setConvertedContent(editor.getData()) }}
                      />
                      <span className="text-danger">
                        {error_list.terms_and_condition}
                      </span>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="label-text py-2">
                        Star Profile File One
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleProfileOneChange(e.target.files)}
                        className="form-control reply-control"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="label-text py-2">
                        Star Profile File Two
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleProfileTwoChange(e.target.files)}
                        className="form-control reply-control"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="label-text py-2">Star Signature</label>

                      {viewSignaturefile && (
                        <img
                          src={viewSignaturefile}
                          className="img-fluid avatar-img-src mb-3"
                          alt=""
                          height="200"
                          width="100%"
                        />
                      )}

                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleSignatureChange(e.target.files)}
                        className="form-control reply-control"
                      />
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-2">
                      <button type="submit" className="btn btnCreate fw-bold" onClick={registerSubmit}>
                        {loading && <i className="fas fa-spinner fa-pulse"></i>}
                        Submit
                      </button>
                    </div>
                  </div>
       
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const EditSuperStar = withStyles(styles)(Demo);
export default EditSuperStar;
